import classNames from 'classnames';
import { observer } from 'mobx-react';
import { ReactNode, type JSX } from 'react';

import { DataAttributes } from '../../common';
import { ExpandablePanel } from '../ExpandablePanel/ExpandablePanel';
import Icon from '../Icon/Icon';
import css from './Accordion.css';

interface AccordionProps extends DataAttributes {
  title: JSX.Element | string;
  className?: string;
  contentClassName?: string;
  titleExpandedClassName?: string;
  titleClassName?: string;
  children: ReactNode;
  isExpanded?: boolean;
  onIsExpandedChange?: (isExpanded: boolean) => void;
}

const Accordion = ({
  children,
  className,
  contentClassName,
  isExpanded,
  onIsExpandedChange,
  title,
  titleClassName,
  titleExpandedClassName,
  ...props
}: AccordionProps) => {
  const renderTitle = (expanded: boolean) => (
    <div className={classNames(css.title, titleClassName, { titleExpandedClassName: expanded })}>
      {title} <Icon name={expanded ? 'angleUp' : 'angleDown'} />
    </div>
  );

  return (
    <ExpandablePanel
      className={classNames(css.Accordion, className)}
      contentClassName={classNames(css.content, contentClassName)}
      renderTitle={renderTitle}
      expanded={isExpanded}
      onExpandChanged={onIsExpandedChange}
      {...props}
    >
      {children}
    </ExpandablePanel>
  );
};

export default observer(Accordion);
